import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import * as AdminActions from '../../store/actions/adminActions';
import Boundary from '../Boundary.js';

class Browsers extends Component {
    componentDidMount(){
        this.init();
    }

    componentDidUpdate(props){
        if(props.match.params.courseId !== this.props.match.params.courseId){
            this.init();
        }
    }

    init = () => {
        // console.log("Initting");

        this.props.getBrowsers(this.props.match.params.courseId, 1, this.props.user.user.id, this.props.user.id);


    }

    
    render(){
        return (

            <div className="panel customPanel">
                <div className="panel-heading border-bottom panel-heading-with-subtext">
                    <h3 className="panel-title">Browsers</h3>
                </div>
                <div className="panel-body no-padding">
                    <Boundary>
                        {!this.props.engagementChartsLoading['browsers'] ?
                            <div id="BrowserGraph" >

                                {this.props.engagementCharts['browsers'] ?
                                    <ReactHighcharts
                                        config={this.props.engagementCharts['browsers']}
                                        isPureConfig={true}
                                        neverReflow={true}
                                        ref="chartde34"
                                    />
                                    :
                                    null
                                }
                            </div>
                        : null
                        }
                    </Boundary>
                        
                </div>
                <div className="panel-footer">
                    <div className="w-200">
                        <div className="form-select-overlay ">
                            <select value={this.props.engagementChartsLength['browsers']} onChange={e => {
                                e.preventDefault();

                                this.props.getBrowsers(this.props.match.params.courseId, e.target.value, this.props.user.user.id, this.props.user.id);
                            }} className="form-control" required="required">
                                <option value={1}>Yesterday</option>
                                <option value={2}>2 day</option>
                                <option value={7}>1 Week</option>
                                <option value={30}>1 Month</option>
                                <option value={365}>1 Year</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getBrowsers: (courseId, length, userId, token) => {
        dispatch(AdminActions.getEngagementChart('browsers', length, courseId, userId, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Browsers));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/Browsers.js